import { render, staticRenderFns } from "./capaian.vue?vue&type=template&id=86ca608a&"
import script from "./capaian.vue?vue&type=script&lang=js&"
export * from "./capaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QInput,QIcon,QList,QItem,QImg,QSeparator,QPagination,QDialog,QCard,QCardSection,QCardActions,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QBtn,QInput,QIcon,QList,QItem,QImg,QSeparator,QPagination,QDialog,QCard,QCardSection,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
